import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Super-admin axios calls intentionally do NOT carry the tenant header —
// they operate at the platform level. We pass the bearer token via the
// stored super-admin JWT for both header and cookie auth.
function authHeaders() {
  const tok = window.localStorage?.getItem('saAccessToken');
  return tok ? { Authorization: `Bearer ${tok}`, 'X-Tenant-Slug': '' } : { 'X-Tenant-Slug': '' };
}

export const saasApi = {
  async login(email, password) {
    const { data } = await axios.post(
      `${API_URL}/api/saas/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    if (data?.access_token) {
      window.localStorage.setItem('saAccessToken', data.access_token);
    }
    return data;
  },
  async logout() {
    try {
      await axios.post(`${API_URL}/api/saas/auth/logout`, {}, { withCredentials: true });
    } catch (_) { /* ignore */ }
    window.localStorage.removeItem('saAccessToken');
  },
  async me() {
    const { data } = await axios.get(`${API_URL}/api/saas/auth/me`, {
      withCredentials: true,
      headers: authHeaders(),
    });
    return data;
  },
  async listPlans() {
    const { data } = await axios.get(`${API_URL}/api/saas/plans`, { headers: authHeaders() });
    return data;
  },
  async createPlan(body) {
    const { data } = await axios.post(`${API_URL}/api/saas/plans`, body, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async updatePlan(id, body) {
    const { data } = await axios.patch(`${API_URL}/api/saas/plans/${id}`, body, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async listTenants() {
    const { data } = await axios.get(`${API_URL}/api/saas/tenants`, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async createTenant(body) {
    const { data } = await axios.post(`${API_URL}/api/saas/tenants`, body, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async updateTenant(slug, body) {
    const { data } = await axios.patch(`${API_URL}/api/saas/tenants/${slug}`, body, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async suspendTenant(slug) {
    const { data } = await axios.delete(`${API_URL}/api/saas/tenants/${slug}`, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async tenantUsage(slug) {
    const { data } = await axios.get(`${API_URL}/api/saas/tenants/${slug}/usage`, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async inviteUser(slug, body) {
    const { data } = await axios.post(`${API_URL}/api/saas/tenants/${slug}/invite`, body, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async listTransactions() {
    const { data } = await axios.get(`${API_URL}/api/saas/billing/transactions`, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async createCheckout(body) {
    const { data } = await axios.post(`${API_URL}/api/saas/billing/checkout`, body, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
  async checkoutStatus(sid) {
    const { data } = await axios.get(`${API_URL}/api/saas/billing/checkout/${sid}`, {
      withCredentials: true, headers: authHeaders(),
    });
    return data;
  },
};
